import { isActionTrigger } from '../helpers';
import { DialogController } from './dialog';
import { TroubleshootingController } from './troubleshooting';
export class VersionDialogController extends DialogController {
    version;
    fullVersion;
    config;
    static $inject = ['$scope', '$mdDialog', 'ThemeService', 'CONFIG'];
    constructor($scope, $mdDialog, themeService, config) {
        super($scope, $mdDialog, themeService);
        this.version = config.VERSION;
        this.fullVersion = `${config.VERSION} ${config.VERSION_MOUNTAIN}`;
        this.config = config;
    }
}
export class FooterController {
    $mdDialog;
    config;
    static $inject = ['CONFIG', '$mdDialog'];
    constructor(CONFIG, $mdDialog) {
        this.$mdDialog = $mdDialog;
        this.config = CONFIG;
    }
    showVersionInfo(ev) {
        if (ev !== undefined && !isActionTrigger(ev)) {
            return;
        }
        this.$mdDialog.show({
            controller: VersionDialogController,
            controllerAs: 'ctrl',
            templateUrl: 'partials/dialog.version.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
        });
    }
    showTroubleshooting(ev) {
        if (ev !== undefined && !isActionTrigger(ev)) {
            return;
        }
        this.$mdDialog.show({
            controller: TroubleshootingController,
            controllerAs: 'ctrl',
            templateUrl: 'partials/dialog.troubleshooting.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
        });
    }
    get changelogUrl() {
        return 'https://github.com/threema-ch/threema-web/blob/' + this.config.GIT_BRANCH + '/CHANGELOG.md';
    }
}
